export const UploadCloud = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="upload-cloud-icon"
    >
      <path
        d="M16.4375 19.4998H18C20.6516 19.4998 22.5 17.5917 22.5 15.214C22.5 13.2906 21.2793 11.4228 19.4765 10.9869C19.4149 9.41108 18.7154 8.23434 17.7499 7.61368C16.8029 7.00493 15.6335 6.93098 14.6015 7.39601C13.774 5.79739 12.1432 4.5 9.99971 4.5C6.81122 4.5 4.56398 7.48367 4.72648 10.5268C2.87607 11.0208 1.5 12.8146 1.5 14.9463C1.5 17.458 3.40572 19.4998 5.74996 19.4998H7.5"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M12 12V22.5M12 12L8.25 15.75M12 12L15.75 15.75"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default UploadCloud
